import React, { useEffect, useState } from "react";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButtonSecondary,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
  LargeButton,
  ButtonText,
} from "../../../styles/Global";
import * as Global from "../../../styles/Global";
import { useForm, Controller } from "react-hook-form";
import "../../../App.scss";
import { useRequestLoginMutation } from "../../../services/playerApi";
import { useEmailDebounceCheckMutation } from "../../../services/emailApi";
import { connect, useSelector } from "react-redux";
import { setPlayer } from "../../../features/player/playerSlice";
import { setOrganizer } from "../../../features/organizer/organizerSlice";
import UseAnimations from "react-useanimations";
import loading from "react-useanimations/lib/loading";
import { BiLogInCircle } from "react-icons/bi";
import { auth, db } from "../../../services/firebaseConfig.js";
import {
  collection,
  doc,
  getDoc,
  setDoc,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { setRefreshOrganizerScreen } from "../../../features/refreshScreen/refreshScreenSlice";

import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
  getAuth,
  sendPasswordResetEmail,
} from "firebase/auth";
import { toast } from "react-toastify";
import QuickToggle from "../../../components/QuickToggle";
import { clearModals } from "../../../features/modals/modalSlice.js";

const mapDispatch = {
  setPlayer,
  setOrganizer,
  setRefreshOrganizerScreen,
  clearModals,
};

const LoginForm = ({
  wizardStep,
  setWizardStep,
  setIsGuest,
  setPlayer,
  setOrganizer,
  type,
  setDisplayModal,
  setRefreshOrganizerScreen,
  clearModals,
}) => {
  const player = useSelector((state) => state.player);
  const [errorCode, setErrorCode] = useState("");
  const [loginData, setLoginData] = useState(null);
  const [showUseSuggested, setShowUseSuggested] = useState(false);
  const [newOrganizer, setNewOrganizer] = useState(false);
  const [organizerForgotPass, setOrganizerForgotPass] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [showFirstLast, setShowFirstLast] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const darkMode = useSelector((state) => state.global.darkMode);
  const params = new URLSearchParams(window.location.search);
  const isDeviceLogin = window.location.pathname.includes("devicelogin");
  // console.log("login params: ", params);
  // console.log("login params token: ", params.get("token"));
  // console.log("login params window.location.href: ", window.location.href);
  const navType = new URL(window.location.href).pathname.split("/")[3];
  const localStoragePlayer =
    JSON.parse(localStorage.getItem("player")) || player;
  // console.log("login form navType: ", navType);
  // console.log("login form localStoragePlayer: ", localStoragePlayer);
  //const auth = getAuth();

  //console.log("player: ", player);
  // console.log("login form type: ", type);
  const { control, handleSubmit, register, formState, setValue } = useForm({
    defaultValues: {
      first: "",
      last: "",
      email: "",
    },
  });
  const [requestLogin, { isLoading: isUpdating, error, data }] =
    useRequestLoginMutation();
  const [
    emailDebounceCheck,
    {
      isLoading: isEmailCheckLoading,
      error: isEmailCheckError,
      data: emailCheckData,
    },
  ] = useEmailDebounceCheckMutation();

  useEffect(() => {
    if (data) {
      // console.log("setting native data: ", data);
      setPlayer(data);
      try {
        window.Android.savePlayerProfile(
          data.userid,
          data.pin,
          data.email,
          data.firstName,
          data.lastName,
          data.displayName,
          "Login",
          data.statusMessage
        );
      } catch (err) {
        console.log("android fail");
      }
      try {
        let appdata = {};
        appdata.userid = data.userid;
        appdata.pin = data.pin;
        appdata.email = data.email;
        appdata.firstName = data.firstName;
        appdata.lastName = data.lastName;
        appdata.displayName = data.displayName;
        appdata.step = "Login";
        appdata.statusMessage = data.statusMessage;
        window.webkit.messageHandlers.savePlayerProfile.postMessage(
          JSON.stringify(appdata)
        );
      } catch (err) {
        console.log("webkit fail");
      }
    }
  }, [data]);
  //console.log("requestLogin error: ", error);
  console.log("requestLogin data: ", data);
  //console.log("requestLogin player: ", player);

  // Handle keyboard visibility on mobile/tablet devices
  useEffect(() => {
    const handleResize = () => {
      // Apply to all mobile/tablet devices - no minimum width restrictions
      const viewportHeight = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;
      const windowHeight = window.innerHeight;
      const keyboardHeight = windowHeight - viewportHeight;

      if (keyboardHeight > 150) {
        // Keyboard is likely open
        setIsKeyboardOpen(true);
        // Scroll the login button into view
        setTimeout(() => {
          const loginButton = document.querySelector('button[type="submit"]');
          if (loginButton) {
            loginButton.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
          }
        }, 300);
      } else {
        setIsKeyboardOpen(false);
      }
    };

    // Listen for visual viewport changes (better keyboard detection)
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", handleResize);
    } else {
      // Fallback for browsers without visualViewport support
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", handleResize);
      } else {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  // Handle input focus events to ensure button visibility
  const handleInputFocus = (event) => {
    // Apply to all mobile/tablet devices - no screen size restrictions
    setTimeout(() => {
      const loginButton = document.querySelector('button[type="submit"]');
      if (loginButton) {
        loginButton.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    }, 500); // Wait for keyboard to fully appear
  };

  function LoginAndSetState(authUser) {
    try {
      // Signed in
      console.log("currently signed in. Now show it: ", authUser);
      authUser.getIdToken(true).then(function (accessToken) {
        console.log("firebase signed in accessToken: ", accessToken);
        setOrganizer({
          bearerToken: accessToken,
          auth: authUser,
          accountid: authUser.auth.currentUser.uid,
          isLogout: false,
        });
      });
      console.log("firebase signed in authUser: ", authUser);
      setRefreshOrganizerScreen();
      setDisplayModal();
      // clearModals()
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      setErrorCode(errorCode);
      console.log("errorCode: ", errorCode);
      console.log("errorMessage: ", errorMessage);
    }
  }

  function HandleError(err) {
    console.log("HandleError: ", err.message);
    toast.error(err.code, {
      autoClose: 10000,
    });
    setIsLoading(false);
  }

  const onSubmit = async (data) => {
    // console.log("onSubmit data: ", data);
    // console.log("onSubmit data TEST: ");
    if (!isUpdating && type !== "organizer") {
      data.token = params.get("token");
      setPlayer({
        ...player,
        email: data.email,
        profileData: {
          firstName: data.first,
          lastName: data.last,
        },
        token: params.get("token"),
      });
      console.log("requestLogin data: ", data);
      // console.log("requestLogin token: ", params.get("token"));
      setLoginData({
        ...data,
        token: params.get("token"),
        status:
          (emailCheckData &&
            emailCheckData.result.code === 1 &&
            showUseSuggested) ||
          (emailCheckData && emailCheckData.result.code > 1)
            ? "continue"
            : "initial",
      });
    } else if (type === "organizer") {
      if (newOrganizer) {
        if (data.password !== data.passwordRetype) {
          console.log("passwords do not match:", data);
          setPasswordError(true);
        } else {
          setIsLoading(true);
          console.log("create organizer data: ", data);
          const userCredential = await createUserWithEmailAndPassword(
            auth,
            data.email.trim(),
            data.password
          ).catch(HandleError);
          console.log("userCredential: ", userCredential);
          await updateProfile(auth.currentUser, {
            displayName: data.organizerFirstLast.trim(),
          });
          const collectionRef = doc(db, "accounts", auth.currentUser.uid);
          console.log("collectionRef: ", collectionRef);
          await setDoc(
            collectionRef,
            {
              email: data.email.trim(),
              createDate: serverTimestamp(),
            },
            { merge: true }
          );
          LoginAndSetState(userCredential.user);
          setIsLoading(false);
        }
      } else if (organizerForgotPass) {
        setIsLoading(true);
        console.log("forgot pass organizer data: ", data);
        sendPasswordResetEmail(auth, data.email)
          .then(() => {
            // Password reset email sent!
            toast.success("Password reset email sent!");
            setOrganizerForgotPass(false);
            setIsLoading(false);
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            // ..
            toast.error(errorMessage);
            setIsLoading(false);
          });
      } else {
        setIsLoading(true);
        const userCredential = await signInWithEmailAndPassword(
          auth,
          data.email,
          data.password
        ).catch(HandleError);
        LoginAndSetState(userCredential.user);
        setIsLoading(false);
      }
    }
  };

  console.log("email debounce check error: ", isEmailCheckError);
  console.log("showUseSuggested: ", showUseSuggested);

  useEffect(() => {
    console.log("useEffect loginData: ", loginData);
    console.log("useEffect emailCheckData: ", emailCheckData);
    if (loginData) {
      emailDebounceCheck({ email: loginData.email });
    }
  }, [loginData]);

  useEffect(() => {
    console.log("email debounce check data: ", emailCheckData);
    console.log("email debounce loginData: ", loginData);
    console.log("email debounce firstName: ", firstName);
    console.log("email debounce lastName: ", lastName);
    const noFirstOrLast =
      emailCheckData &&
      emailCheckData.result.code === 0 &&
      (emailCheckData.result.firstName === "" ||
        emailCheckData.result.lastName === "") &&
      (firstName === "" || lastName === "");
    if (
      (((emailCheckData && emailCheckData.result.code === 1) ||
        (emailCheckData && emailCheckData.result.code > 1)) &&
        !showUseSuggested &&
        loginData.status !== "continue") ||
      noFirstOrLast
    ) {
      console.log("WE ARE HERE");
      if (emailCheckData && emailCheckData.result.code === 1) {
        setShowUseSuggested(true);
      }
      if (noFirstOrLast) {
        console.log(
          "noFirstOrLast. Require user to enter first and last name: ",
          noFirstOrLast
        );
        //If first and/or last are blank, set the field values and require user to enter them
        setTimeout(() => {
          setValue("first", emailCheckData.result.firstName);
          setValue("last", emailCheckData.result.lastName);
          setFirstName(emailCheckData.result.firstName);
          setLastName(emailCheckData.result.lastName);
        }, 500);
      }
      setShowFirstLast(true);
    } else if (
      (emailCheckData &&
        emailCheckData.result.code === 0 &&
        emailCheckData.result.firstName !== "" &&
        emailCheckData.result.lastName !== "" &&
        emailCheckData.result.userId !== "") ||
      (emailCheckData &&
        emailCheckData.result.code > 0 &&
        loginData &&
        loginData.status === "continue") ||
      (firstName !== "" && lastName !== "")
    ) {
      console.log("REQUESTING LOGIN");
      // request login data. First and last are not blank, email is valid.
      const requestBody = {
        ...loginData,
        needsUpdate: firstName !== "" && lastName !== "",
        userId: emailCheckData ? emailCheckData.result.userId : "",
      };
      setPlayer({
        ...player,
        requestBody: requestBody,
      });
      console.log("Login requestBody: ", requestBody);
      requestLogin(requestBody);
      setLoginData(null);
    } else {
      console.log("Did not hit correct if statement");
    }

    return () => {
      setFirstName("");
      setLastName("");
      setShowFirstLast(false);
      setShowUseSuggested(false);
    };
  }, [emailCheckData]);

  function SetCorrectedEmail() {
    setShowUseSuggested(false);
    setValue("email", emailCheckData.result.suggest);
  }

  // Handle keyboard navigation for email suggestion
  const handleSuggestionKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      SetCorrectedEmail();
    }
  };

  // Handle form submission with Enter key
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSubmit(onSubmit)();
    }
  };

  console.log("showUseSuggested: ", showUseSuggested);

  return (
    <>
      {type === "organizer" && !isDeviceLogin && (
        <FlexColumn justify="center" align="center">
          {!organizerForgotPass && (
            <QuickToggle
              style={{ width: "90%", marginBottom: 10, marginTop: 30 }}
              option1="Login"
              option2="Create Account"
              selected={newOrganizer}
              setSelected={setNewOrganizer}
            />
          )}
          <h1 style={{ textAlign: "center" }}>
            {newOrganizer
              ? "Nice to meet you!"
              : organizerForgotPass
              ? "Recover Password"
              : "Organizer Login"}
          </h1>
        </FlexColumn>
      )}
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyDown}>
        {type !== "organizer" && showFirstLast ? (
          <>
            <FlexRow
              align="center"
              style={{ width: "100%", marginBottom: 15 }}
              justify="center"
            >
              <Text style={{ textAlign: "center" }}>
                Please fill out your first and last name
              </Text>
            </FlexRow>
            <Controller
              name="first"
              control={control}
              render={({ field }) => (
                <div className="inputField">
                  <FormInputField
                    {...register("first", { required: true })}
                    id="first-name-input"
                    label="First Name"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    autoComplete="given-name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    tabIndex={1}
                  />
                </div>
              )}
            />
            {formState.errors.first && (
              <Text size=".8em" style={{ paddingLeft: 15 }} color="red">
                First name required
              </Text>
            )}
            <Controller
              name="last"
              control={control}
              render={({ field }) => (
                <div className="inputField">
                  <FormInputField
                    {...register("last", { required: "Last name required" })}
                    id="last-name-input"
                    label="Last Name"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    autoComplete="family-name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    tabIndex={2}
                  />
                </div>
              )}
            />
            {formState.errors.last && (
              <Text size=".8em" style={{ paddingLeft: 15 }} color="red">
                Last name required
              </Text>
            )}
          </>
        ) : null}
        {type === "organizer" && organizerForgotPass && (
          <FlexRow justify="center">
            <Text style={{ textAlign: "center" }}>
              Get instructions sent to this email that explain how to reset your
              password.
            </Text>
          </FlexRow>
        )}
        {newOrganizer && (
          <Controller
            name="organizerFirstLast"
            control={control}
            rules={{
              required: "Please enter first and last name!",
            }}
            render={({ field: { onChange, value, ref } }) => (
              <div className="inputField">
                <FormInputField
                  ref={ref}
                  value={value || ""}
                  onChange={(event) => {
                    onChange(event.target.value);
                    setErrorCode(null);
                  }}
                  onBlur={(event) => {
                    // Handle autofill detection on blur
                    const autofilledValue = event.target.value;
                    if (autofilledValue && autofilledValue !== value) {
                      onChange(autofilledValue);
                    }
                  }}
                  onFocus={(event) => {
                    // Handle autofill detection on focus
                    setTimeout(() => {
                      const autofilledValue = event.target.value;
                      if (autofilledValue && autofilledValue !== value) {
                        onChange(autofilledValue);
                      }
                    }, 100);
                    // Handle keyboard visibility on tablets
                    handleInputFocus(event);
                  }}
                  id="organizer-name-input"
                  label="First & Last Name"
                  variant="outlined"
                  fullWidth
                  margin="dense"
                  autoComplete="name"
                  tabIndex={1}
                />
              </div>
            )}
          />
        )}
        <Controller
          name="email"
          control={control}
          rules={{
            required: "Email is required",
            pattern: {
              value:
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: "Please enter a valid email",
            },
          }}
          render={({ field: { onChange, value, ref } }) => (
            <div className="inputField">
              <FormInputField
                ref={ref}
                value={value || ""}
                onChange={(event) => {
                  const newValue = event.target.value.toLowerCase().trim();
                  onChange(newValue);
                  setErrorCode(null);
                }}
                onBlur={(event) => {
                  // Handle autofill detection on blur
                  const autofilledValue = event.target.value;
                  if (autofilledValue && autofilledValue !== value) {
                    onChange(autofilledValue.toLowerCase().trim());
                  }
                }}
                onFocus={(event) => {
                  // Handle autofill detection on focus
                  setTimeout(() => {
                    const autofilledValue = event.target.value;
                    if (autofilledValue && autofilledValue !== value) {
                      onChange(autofilledValue.toLowerCase().trim());
                    }
                  }, 100);
                  // Handle keyboard visibility on tablets
                  handleInputFocus(event);
                }}
                id="email-input"
                label="Email"
                variant="outlined"
                fullWidth
                margin="dense"
                autoComplete="email"
                type="email"
                tabIndex={1}
                autoFocus
                required
              />
            </div>
          )}
        />
        {formState.errors.email?.message && (
          <Text size=".8em" style={{ paddingLeft: 15 }} color="red">
            {formState.errors.email.message}
          </Text>
        )}
        {emailCheckData &&
          emailCheckData.result.code === 1 &&
          showUseSuggested && (
            <FlexRow align="center" justify="center">
              <Text
                size=".8em"
                style={{
                  marginTop: 5,
                  marginLeft: 15,
                }}
              >
                Did you mean
              </Text>
              <Text
                size=".8em"
                style={{
                  marginTop: 5,
                  textDecoration: "underline",
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                onClick={() => SetCorrectedEmail()}
                onKeyDown={handleSuggestionKeyDown}
                tabIndex={10}
                role="button"
                aria-label={`Use suggested email: ${emailCheckData.result.suggest}`}
              >
                {emailCheckData.result.suggest}?
              </Text>
            </FlexRow>
          )}
        {type === "organizer" && !organizerForgotPass && (
          <>
            <Controller
              name="password"
              control={control}
              rules={{
                required: "Please enter password",
              }}
              render={({ field: { onChange, value, ref } }) => (
                <div className="inputField">
                  <FormInputField
                    ref={ref}
                    value={value || ""}
                    onChange={(event) => {
                      onChange(event.target.value);
                      setErrorCode(null);
                    }}
                    onBlur={(event) => {
                      // Handle autofill detection on blur
                      const autofilledValue = event.target.value;
                      if (autofilledValue && autofilledValue !== value) {
                        onChange(autofilledValue);
                      }
                    }}
                    onFocus={(event) => {
                      // Handle autofill detection on focus
                      setTimeout(() => {
                        const autofilledValue = event.target.value;
                        if (autofilledValue && autofilledValue !== value) {
                          onChange(autofilledValue);
                        }
                      }, 100);
                      // Handle keyboard visibility on tablets
                      handleInputFocus(event);
                    }}
                    id="password-input"
                    label="Password"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    autoComplete="current-password"
                    type="password"
                    tabIndex={newOrganizer ? 3 : 2}
                  />
                </div>
              )}
            />
            {newOrganizer && (
              <Controller
                name="passwordRetype"
                control={control}
                rules={{
                  required: "Please enter password",
                }}
                render={({ field: { onChange, value, ref } }) => (
                  <div className="inputField">
                    <FormInputField
                      ref={ref}
                      value={value || ""}
                      onChange={(event) => {
                        onChange(event.target.value);
                      }}
                      onBlur={(event) => {
                        // Handle autofill detection on blur
                        const autofilledValue = event.target.value;
                        if (autofilledValue && autofilledValue !== value) {
                          onChange(autofilledValue);
                        }
                      }}
                      onFocus={(event) => {
                        // Handle autofill detection on focus
                        setTimeout(() => {
                          const autofilledValue = event.target.value;
                          if (autofilledValue && autofilledValue !== value) {
                            onChange(autofilledValue);
                          }
                        }, 100);
                        // Handle keyboard visibility on tablets
                        handleInputFocus(event);
                      }}
                      id="password-retype-input"
                      label="Re-type password"
                      variant="outlined"
                      fullWidth
                      margin="dense"
                      autoComplete="new-password"
                      type="password"
                      tabIndex={4}
                    />
                  </div>
                )}
              />
            )}
          </>
        )}
        {errorCode && (
          <Text size=".8em" style={{ paddingLeft: 15 }} color="red">
            {errorCode === "auth/user-not-found"
              ? "Email not found"
              : errorCode === "auth/wrong-password"
              ? "Incorrect Password"
              : errorCode}
          </Text>
        )}
        {passwordError && (
          <Text size=".8em" style={{ paddingLeft: 15 }} color="red">
            Passwords do not match!
          </Text>
        )}
        <FlexColumn
          justify="center"
          align="center"
          style={{
            paddingBottom: isKeyboardOpen ? "20px" : "0",
            marginBottom: isKeyboardOpen ? "20px" : "0",
          }}
        >
          {type !== "organizer" && (
            <>
              <span
                style={{
                  display: "block",
                  marginTop: 20,
                  textAlign: "center",
                  fontSize:
                    emailCheckData &&
                    emailCheckData.result.code === 1 &&
                    ".9em",
                  color:
                    (emailCheckData &&
                      emailCheckData.result.code === 1 &&
                      showUseSuggested) ||
                    (emailCheckData && emailCheckData.result.code > 1)
                      ? Global.red
                      : darkMode
                      ? "#EBF1F4"
                      : "#333",
                }}
              >
                {emailCheckData &&
                emailCheckData.result.code === 1 &&
                showUseSuggested
                  ? "The email entered is invalid or unreachable."
                  : emailCheckData && emailCheckData.result.code > 1
                  ? "There might be an issue with your email. Please make sure it's correct then create your account."
                  : "Entering your email allows us to rate your play and you can track results"}
              </span>
            </>
          )}

          <LargeButton
            style={{
              margin: isDeviceLogin ? '10px auto 0' : "20px auto 0",
              alignSelf: "flex-start",
              flex: 0,
              padding: isDeviceLogin && '5px 10px',
              borderRadius: isDeviceLogin && 5
            }}
            type="submit"
            tabIndex={2}
          >
            <ButtonText>
              {isUpdating || isEmailCheckLoading || isLoading
                ? "Just a sec"
                : type === "organizer"
                ? newOrganizer
                  ? "Create"
                  : organizerForgotPass
                  ? "Send"
                  : "log  in"
                : (emailCheckData &&
                    emailCheckData.result.code === 1 &&
                    showUseSuggested) ||
                  (emailCheckData && emailCheckData.result.code > 1)
                ? "Continue Anyway"
                : "Next"}
            </ButtonText>
            {isUpdating || isEmailCheckLoading || isLoading ? (
              <UseAnimations
                strokeColor="#fff"
                animation={loading}
                size={20}
                wrapperStyle={{ marginLeft: 10 }}
              />
            ) : (
              <BiLogInCircle size={20} color="#fff" style={{ marginLeft: 5 }} />
            )}
          </LargeButton>
          {
            !isDeviceLogin &&
          <FlexRow style={{ marginTop: 15 }}>
            {navType !== "player" && !newOrganizer && (
              <Text
                size=".8em"
                style={{ cursor: "pointer" }}
                onClick={() => setOrganizerForgotPass(!organizerForgotPass)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setOrganizerForgotPass(!organizerForgotPass);
                  }
                }}
                tabIndex={3}
                role="button"
                aria-label={
                  organizerForgotPass
                    ? "Cancel password reset"
                    : "Reset password"
                }
              >
                {organizerForgotPass ? "Cancel" : "Forgot Password"}
              </Text>
            )}
          </FlexRow>
          }
        </FlexColumn>
      </form>
    </>
  );
};

export default connect(null, mapDispatch)(LoginForm);
